import type { ClientUser } from '@exam-room/graphql';

import { type UserProfile } from '../types';

export function mapUserProfile(profile: ClientUser): UserProfile {
  const { firstname, middleName, lastname, username, email, imageUrl, title, idNumber } =
    profile ?? {};

  return {
    firstname,
    lastname,
    displayName: `${title} ${firstname}${middleName ? ` ${middleName}` : ''} ${lastname}`,
    username,
    email,
    avatarImageUrl: imageUrl,
    idNumber,
  };
}
